import { GetAccidentReportFormUrl } from "@/common/CommonConstants";

export const DashboardConstants = {
  Dashboard: "ダッシュボード",
  TitleManual: "充電サービス関連マニュアル",
  TitleForm: "充電サービス関連フォーム",
} as const;

type DashboardForm = {
  name: string;
  url: string;
};

export const DashboardForms: DashboardForm[] = [
  {
    name: "【重要】事故報告（車両・充電設備）の連絡",
    url: GetAccidentReportFormUrl(),
  },
  {
    name: "EV車両の無線番号の提出",
    url: "https://32263817.form.kintoneapp.com/public/a75e7147043f85dc805fe23ba619fda6578a429c5c4a7f05b7d0f098ce962a50",
  },
  {
    name: "EV車両のGO Reserve・NRSへの移管連絡",
    url: "https://32263817.form.kintoneapp.com/public/e030fb67a4efc27dbf2ba6c4137a844426e475e239601bd17ba7cebf54b77806",
  },
  {
    name: "急速充電器の共同利用申請",
    url: "https://forms.gle/hyPa5tJkaVqhJ5iC6",
  },
  {
    name: "参画表明書の提出",
    url: "https://32263817.form.kintoneapp.com/public/a12aaecc9fb57d1d99f86d299f10682739b48649c0a58512cb38ef31d6e2b0bc",
  },
  {
    name: "決算書類の提出",
    url: "https://32263817.form.kintoneapp.com/public/de6a70a5bf24cfc120b81d5a52fc65eaf15d7cc8dfc380129df97b2b3c34b5e5",
  },
  {
    name: "日産リーフ オプションカラーの発注書",
    url: "https://32263817.form.kintoneapp.com/public/0b450833790d97e01d00f4297d14b0ec5caf8237f936bed9227ada27f2503133",
  },
  {
    name: "日産アリア オプションカラーの発注書",
    url: "https://32263817.form.kintoneapp.com/public/a3f3d27d287cac4be287d70119ee7f565427369539081dd16aac81ef5281cfd7",
  },
  {
    name: "トヨタbZ4X オプションカラーの発注書",
    url: "https://32263817.form.kintoneapp.com/public/46dc714ef5713e3d058d2e487b8dce01d23963d89d4953c4ee89c982d4c14363",
  },
];
